import React, { useState, useEffect, useRef } from 'react';
import './App.css'; // CSS 파일 임포트

const FormalIQTest = () => {
  // 테스트 상태 관리
  const [testState, setTestState] = useState('intro'); // intro, instructions, test, result
  const [currentSection, setCurrentSection] = useState(0);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [answers, setAnswers] = useState({});
  const [timer, setTimer] = useState(null);
  const [remainingTime, setRemainingTime] = useState(0);
  const [age, setAge] = useState('');
  const timerRef = useRef(null);

  // 테스트 구성
  const testSections = [
    {
      name: '언어이해',
      description: '단어의 의미, 개념 간의 관계, 일반 지식을 측정합니다.',
      timeLimit: 300, // 5분
      questions: [
        {
          type: 'vocabulary',
          question: '"민주주의"의 가장 정확한 정의는 무엇인가요?',
          options: [
            '국민이 선출한 대표자들에 의한 통치',
            '국민에 의한, 국민을 위한, 국민의 통치',
            '정부의 간섭 없이 자유롭게 살 권리',
            '모든 사람들이 동등한 권리를 가지는 사회'
          ],
          correctAnswer: 1
        },
        {
          type: 'similarities',
          question: '사과와 오렌지의 공통점은 무엇인가요?',
          options: [
            '둘 다 동그란 모양이다',
            '둘 다 단맛이 있다',
            '둘 다 과일이다',
            '둘 다 비타민 C가 풍부하다'
          ],
          correctAnswer: 2
        },
        {
          type: 'general_knowledge',
          question: '태양계에서 가장 큰 행성은?',
          options: [
            '지구',
            '토성',
            '목성',
            '해왕성'
          ],
          correctAnswer: 2
        },
        {
          type: 'vocabulary',
          question: '"역설(paradox)"의 의미로 가장 적절한 것은?',
          options: [
            '동의어나 유사한 단어',
            '모순되거나 비논리적으로 보이지만 사실일 수 있는 진술',
            '반의어 또는 대조되는 단어',
            '다른 의미로 해석될 수 있는 문장'
          ],
          correctAnswer: 1
        },
        {
          type: 'similarities',
          question: '시와 소설의 공통점은?',
          options: [
            '둘 다 운율이 있다',
            '둘 다 문학 작품이다',
            '둘 다 등장인물이 있다',
            '둘 다 같은 길이다'
          ],
          correctAnswer: 1
        }
      ]
    },
    {
      name: '지각추론',
      description: '시각적 패턴 인식, 공간 관계 이해, 논리적 추론 능력을 측정합니다.',
      timeLimit: 300, // 5분
      questions: [
        {
          type: 'matrix_reasoning',
          question: '다음 패턴에서 빈칸에 들어갈 도형은?',
          content: '(이미지 설명: 3x3 그리드에 도형들이 나열되어 있고, 마지막 칸이 비어있음)',
          options: [
            'A', 'B', 'C', 'D'
          ],
          correctAnswer: 2
        },
        {
          type: 'pattern_completion',
          question: '다음 수열에서 다음에 올 숫자는? 2, 6, 12, 20, 30, ...',
          options: [
            '36', '40', '42', '48'
          ],
          correctAnswer: 2
        },
        {
          type: 'visual_puzzle',
          question: '주어진 조각들로 완성할 수 있는 도형은?',
          content: '(이미지 설명: 퍼즐 조각 여러 개와 이를 조합했을 때 만들 수 있는 도형 4가지)',
          options: [
            'A', 'B', 'C', 'D'
          ],
          correctAnswer: 0
        },
        {
          type: 'matrix_reasoning',
          question: '다음 논리 패턴에서 빈칸에 들어갈 올바른 도형은?',
          content: '(이미지 설명: 논리 규칙에 따라 배열된 도형들의 패턴, 마지막 칸이 비어있음)',
          options: [
            'A', 'B', 'C', 'D'
          ],
          correctAnswer: 1
        },
        {
          type: 'pattern_completion',
          question: '다음 패턴에서 다음에 올 글자는? A, C, F, J, ...',
          options: [
            'M', 'N', 'O', 'P'
          ],
          correctAnswer: 2
        }
      ]
    },
    {
      name: '작업기억',
      description: '정보를 일시적으로 저장하고 조작하는 능력을 측정합니다.',
      timeLimit: 240, // 4분
      questions: [
        {
          type: 'digit_span',
          question: '다음 숫자를 순서대로 기억했다가 선택하세요: 5 8 2 1 9',
          showTime: 3, // 3초 동안 보여줌
          options: [
            '5 8 2 1 9',
            '5 8 1 2 9',
            '5 8 2 9 1',
            '5 2 8 1 9'
          ],
          correctAnswer: 0
        },
        {
          type: 'digit_span_backward',
          question: '다음 숫자를 거꾸로 기억했다가 선택하세요: 7 1 4 9',
          showTime: 3,
          options: [
            '7 1 4 9',
            '9 4 1 7',
            '4 1 7 9',
            '9 4 7 1'
          ],
          correctAnswer: 1
        },
        {
          type: 'arithmetic',
          question: '10에서 3을 빼고 2를 곱한 후 4를 더하면?',
          options: [
            '16', '18', '20', '22'
          ],
          correctAnswer: 1
        },
        {
          type: 'digit_span',
          question: '다음 숫자를 순서대로 기억했다가 선택하세요: 3 7 2 9 6 1',
          showTime: 4,
          options: [
            '3 7 2 9 6 1',
            '3 7 2 9 1 6',
            '3 7 9 2 6 1',
            '3 2 7 9 6 1'
          ],
          correctAnswer: 0
        },
        {
          type: 'arithmetic',
          question: '23에 7을 더한 후 5로 나누고 3을 빼면?',
          options: [
            '3', '4', '5', '6'
          ],
          correctAnswer: 1
        }
      ]
    },
    {
      name: '처리속도',
      description: '단순한 시각적 정보를 빠르게 처리하는 능력을 측정합니다.',
      timeLimit: 120, // 2분
      questions: [
        {
          type: 'symbol_search',
          question: '왼쪽의 기호와 일치하는 기호를 오른쪽에서 빠르게 찾으세요.',
          content: '(이미지 설명: 왼쪽에 2개의 대상 기호, 오른쪽에 검색할 10개의 기호 나열)',
          options: [
            'A', 'B', 'C', 'D'
          ],
          correctAnswer: 2,
          timeLimit: 10 // 10초
        },
        {
          type: 'coding',
          question: '각 기호에 맞는 숫자를 빠르게 입력하세요.',
          content: '◆=1, ■=2, ●=3, ★=4, ▲=5 일 때, ■◆●■◆ 는?',
          options: [
            '1-2-3-1-2', 
            '1-3-2-1-2', 
            '2-1-3-1-2', 
            '2-1-3-2-1'
          ],
          correctAnswer: 2,
          timeLimit: 15
        },
        {
          type: 'visual_scanning',
          question: '5의 개수를 빠르게 세어 선택하세요.',
          content: '8 3 5 7 2 5 4 1 5 9 0 5 7 2 3 5 1 8 4 5',
          options: [
            '5개', '6개', '7개', '8개'
          ],
          correctAnswer: 1,
          timeLimit: 10
        },
        {
          type: 'symbol_search',
          question: '표적 기호와 동일한 기호를 빠르게 모두 찾으세요.',
          content: '◆가 총 몇 개 있나요? ◆◇◆□○◇○◆■□◆◇■○◆',
          options: [
            '2개', '3개', '4개', '5개'
          ],
          correctAnswer: 3,
          timeLimit: 12
        },
        {
          type: 'coding',
          question: '규칙에 따라 빠르게 기호를 변환하세요.',
          content: '1→A, 2→B, 3→C, 4→D, 5→E 일 때, 2-1-3-2-1 은?',
          options: [
            'A-B-C-A-B', 
            'A-B-C-B-A', 
            'B-A-C-A-B', 
            'B-A-C-B-A'
          ],
          correctAnswer: 3,
          timeLimit: 15
        }
      ]
    }
  ];

  // 타이머 설정
  useEffect(() => {
    if (timer === null || testState !== 'test') return;

    if (remainingTime <= 0) {
      // 시간 종료, 다음 섹션이나 질문으로 이동
      handleTimerEnd();
      return;
    }

    timerRef.current = setTimeout(() => {
      setRemainingTime(time => time - 1);
    }, 1000);

    return () => clearTimeout(timerRef.current);
  }, [remainingTime, timer, testState]);

  // 타이머 종료 처리
  const handleTimerEnd = () => {
    if (currentQuestion < testSections[currentSection].questions.length - 1) {
      // 다음 질문으로
      setCurrentQuestion(currentQuestion + 1);
      
      // 질문별 시간 제한이 있는 경우
      const questionTimeLimit = testSections[currentSection].questions[currentQuestion + 1].timeLimit;
      if (questionTimeLimit) {
        setRemainingTime(questionTimeLimit);
      }
    } else if (currentSection < testSections.length - 1) {
      // 다음 섹션으로
      setCurrentSection(currentSection + 1);
      setCurrentQuestion(0);
      setRemainingTime(testSections[currentSection + 1].timeLimit);
    } else {
      // 테스트 종료
      finishTest();
    }
  };

  // 테스트 시작
  const startTest = () => {
    setTestState('instructions');
  };

  // 지시사항 확인 후 테스트 시작
  const startSection = () => {
    setTestState('test');
    setRemainingTime(testSections[currentSection].timeLimit);
    setTimer(true);
  };

  // 답변 처리
  const handleAnswer = (answerIndex) => {
    // 현재 섹션과 질문에 대한 답변 저장
    setAnswers(prev => ({
      ...prev,
      [`${currentSection}-${currentQuestion}`]: answerIndex
    }));

    // 다음 질문으로 이동
    if (currentQuestion < testSections[currentSection].questions.length - 1) {
      setCurrentQuestion(currentQuestion + 1);
      
      // 질문별 시간 제한이 있는 경우
      const questionTimeLimit = testSections[currentSection].questions[currentQuestion + 1].timeLimit;
      if (questionTimeLimit) {
        setRemainingTime(questionTimeLimit);
      }
    } else if (currentSection < testSections.length - 1) {
      // 다음 섹션으로
      clearTimeout(timerRef.current);
      setTestState('instructions');
      setCurrentSection(currentSection + 1);
      setCurrentQuestion(0);
      setTimer(null);
    } else {
      // 테스트 종료
      finishTest();
    }
  };

  // 테스트 종료 및 결과 계산
  const finishTest = () => {
    clearTimeout(timerRef.current);
    setTestState('result');
    setTimer(null);
  };

  // IQ 점수 계산
  const calculateIQ = () => {
    let correctAnswers = 0;
    let totalQuestions = 0;

    testSections.forEach((section, sectionIndex) => {
      section.questions.forEach((question, questionIndex) => {
        totalQuestions++;
        const userAnswer = answers[`${sectionIndex}-${questionIndex}`];
        if (userAnswer === question.correctAnswer) {
          correctAnswers++;
        }
      });
    });

    // 단순화된 IQ 계산 (실제 IQ 테스트는 훨씬 복잡한 표준화 과정을 거침)
    const percentageCorrect = (correctAnswers / totalQuestions) * 100;
    
    // 매우 단순화된 환산 공식 (실제와 다름)
    let estimatedIQ;
    if (percentageCorrect >= 95) estimatedIQ = 130 + Math.floor(Math.random() * 10);
    else if (percentageCorrect >= 85) estimatedIQ = 120 + Math.floor(Math.random() * 10);
    else if (percentageCorrect >= 75) estimatedIQ = 110 + Math.floor(Math.random() * 10);
    else if (percentageCorrect >= 65) estimatedIQ = 100 + Math.floor(Math.random() * 10);
    else if (percentageCorrect >= 50) estimatedIQ = 90 + Math.floor(Math.random() * 10);
    else if (percentageCorrect >= 35) estimatedIQ = 80 + Math.floor(Math.random() * 10);
    else estimatedIQ = 70 + Math.floor(Math.random() * 10);

    return {
      score: estimatedIQ,
      correct: correctAnswers,
      total: totalQuestions,
      percentage: percentageCorrect.toFixed(1)
    };
  };

  // 연령 입력 처리
  const handleAgeChange = (e) => {
    setAge(e.target.value);
  };

  // 현재 섹션의 정보 가져오기
  const currentSectionInfo = testSections[currentSection];
  const currentQuestionInfo = currentSectionInfo?.questions[currentQuestion];

  return (
    <div className="iq-test-container max-w-3xl mx-auto p-6 bg-white rounded-lg shadow-lg">
      {testState === 'intro' && (
        <div className="space-y-6">
          <h1 className="test-title text-3xl font-bold text-center">정식 IQ 테스트</h1>
          <p className="text-lg text-gray-700">
            이 테스트는 실제 정식 IQ 테스트와 유사한 방식으로 구성되었습니다. 
            총 4개 영역, 20개 문항으로 구성되어 있으며, 각 영역별로 시간 제한이 있습니다.
          </p>
          <div className="bg-blue-50 p-4 rounded-md">
            <h3 className="font-bold text-blue-800">테스트 영역</h3>
            <ul className="list-disc pl-5 space-y-2 mt-2">
              <li>언어이해 (5문항): 단어 정의, 개념 유사성, 일반 지식</li>
              <li>지각추론 (5문항): 패턴 인식, 시각적 퍼즐, 논리적 추론</li>
              <li>작업기억 (5문항): 숫자 외우기, 암산, 정보 조작</li>
              <li>처리속도 (5문항): 빠른 시각 처리, 기호 검색</li>
            </ul>
          </div>
          <div className="space-y-4">
            <p className="text-gray-700">테스트를 시작하기 전에 귀하의 연령대를 선택해주세요:</p>
            <select 
              value={age} 
              onChange={handleAgeChange}
              className="w-full p-2 border border-gray-300 rounded-md"
            >
              <option value="">연령대 선택</option>
              <option value="10-16">10-16세</option>
              <option value="17-25">17-25세</option>
              <option value="26-35">26-35세</option>
              <option value="36-50">36-50세</option>
              <option value="51-65">51-65세</option>
              <option value="66+">66세 이상</option>
            </select>
          </div>
          <div className="text-center pt-4">
            <button
              onClick={startTest}
              disabled={!age}
              className={`primary-button py-3 px-6 rounded-lg font-semibold ${
                age ? 'bg-blue-600 hover:bg-blue-700 text-white' : 'bg-gray-300 text-gray-500 cursor-not-allowed'
              }`}
            >
              테스트 시작하기
            </button>
          </div>
          <div className="mt-4 text-sm text-gray-500 text-center">
            참고: 이 테스트는 교육 및 시뮬레이션 목적으로 제작되었으며, 전문적인 심리 평가를 대체할 수 없습니다.
          </div>
        </div>
      )}

      {testState === 'instructions' && currentSectionInfo && (
        <div className="space-y-6">
          <h2 className="section-title text-2xl font-bold">{currentSectionInfo.name} 영역</h2>
          <div className="bg-yellow-50 p-4 rounded-md">
            <p className="text-gray-800">{currentSectionInfo.description}</p>
            <p className="mt-2 font-semibold">
              시간 제한: {Math.floor(currentSectionInfo.timeLimit / 60)}분 {currentSectionInfo.timeLimit % 60}초
            </p>
          </div>
          <p className="text-gray-700">
            이 영역에서는 총 {currentSectionInfo.questions.length}개의 문항이 출제됩니다.
            각 문항은 시간 제한 내에 답변해야 합니다.
          </p>
          <div className="bg-blue-50 p-4 rounded-md">
            <h3 className="font-semibold text-blue-800">지시사항</h3>
            <ul className="list-disc pl-5 space-y-1 mt-2">
              <li>각 문항을 주의 깊게 읽고 가장 적절한 답을 선택하세요.</li>
              <li>모르는 문항이 있으면 추측하여 답하세요.</li>
              <li>영역별 시간이 종료되면 자동으로 다음 영역으로 넘어갑니다.</li>
            </ul>
          </div>
          <div className="text-center pt-4">
            <button
              onClick={startSection}
              className="primary-button bg-blue-600 hover:bg-blue-700 text-white py-3 px-6 rounded-lg font-semibold"
            >
              이 영역 시작하기
            </button>
          </div>
        </div>
      )}

      {testState === 'test' && currentSectionInfo && currentQuestionInfo && (
        <div className="space-y-6">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-bold">{currentSectionInfo.name}</h2>
            <div className="bg-gray-100 px-3 py-1 rounded-full">
              <span className={`timer ${remainingTime <= 10 ? 'warning text-red-600 font-bold' : ''}`}>
                {Math.floor(remainingTime / 60)}:{(remainingTime % 60).toString().padStart(2, '0')}
              </span>
            </div>
          </div>

          <div className="progress-indicator flex justify-between text-sm text-gray-600">
            <span>문항 {currentQuestion + 1} / {currentSectionInfo.questions.length}</span>
            <span>진행률: {Math.floor((((currentSection * 5) + currentQuestion + 1) / 20) * 100)}%</span>
          </div>

          <div className="bg-gray-50 p-5 rounded-lg">
            <p className="text-lg font-medium">{currentQuestionInfo.question}</p>
            
            {currentQuestionInfo.content && (
              <div className="my-4 p-3 bg-white rounded border border-gray-200 text-center font-mono">
                {currentQuestionInfo.content}
              </div>
            )}
          </div>

          <div className="space-y-3 mt-4">
            {currentQuestionInfo.options.map((option, index) => (
              <button
                key={index}
                onClick={() => handleAnswer(index)}
                className="option-button w-full text-left p-3 border border-gray-300 rounded-lg hover:bg-gray-100 transition-colors"
              >
                {option}
              </button>
            ))}
          </div>
        </div>
      )}

      {testState === 'result' && (
        <div className="space-y-6">
          <h2 className="test-title text-2xl font-bold text-center">IQ 테스트 결과</h2>
          
          {(() => {
            const result = calculateIQ();
            
            return (
              <div className="space-y-6">
                <div className="result-card info-card bg-blue-50 p-6 rounded-lg text-center">
                  <p className="text-gray-700 mb-2">귀하의 예상 IQ 점수:</p>
                  <p className="result-score text-5xl font-bold text-blue-600">{result.score}</p>
                </div>
                
                <div className="stats-grid grid grid-cols-3 gap-4 text-center">
                  <div className="stat-card bg-gray-50 p-4 rounded-lg">
                    <p className="text-sm text-gray-500">정답 수</p>
                    <p className="text-xl font-semibold">{result.correct} / {result.total}</p>
                  </div>
                  <div className="stat-card bg-gray-50 p-4 rounded-lg">
                    <p className="text-sm text-gray-500">정답률</p>
                    <p className="text-xl font-semibold">{result.percentage}%</p>
                  </div>
                  <div className="stat-card bg-gray-50 p-4 rounded-lg">
                    <p className="text-sm text-gray-500">연령대</p>
                    <p className="text-xl font-semibold">{age}</p>
                  </div>
                </div>
                
                <div className="info-card warning bg-yellow-50 p-4 rounded-md">
                  <h3 className="font-bold text-yellow-800 mb-2">점수 해석</h3>
                  <p>
                    {result.score >= 130 && "매우 우수 (Very Superior): 상위 2.2% 이내의 점수입니다."}
                    {result.score >= 120 && result.score < 130 && "우수 (Superior): 상위 6.7% 이내의 점수입니다."}
                    {result.score >= 110 && result.score < 120 && "평균 상 (High Average): 상위 16% 이내의 점수입니다."}
                    {result.score >= 90 && result.score < 110 && "평균 (Average): 인구의 약 50%가 이 범위에 속합니다."}
                    {result.score >= 80 && result.score < 90 && "평균 하 (Low Average): 하위 16% 이내의 점수입니다."}
                    {result.score >= 70 && result.score < 80 && "경계선 (Borderline): 하위 6.7% 이내의 점수입니다."}
                    {result.score < 70 && "평균 이하 (Below Average): 하위 2.2% 이내의 점수입니다."}
                  </p>
                </div>
                
                <div className="result-card bg-gray-50 p-4 rounded-md">
                  <h3 className="font-bold text-gray-700 mb-2">주의사항</h3>
                  <p className="text-sm text-gray-600">
                    이 테스트는 정식 IQ 테스트의 시뮬레이션으로, 전문 심리학자가 실시하는 표준화된 검사 결과와 차이가 있을 수 있습니다. 
                    정확한 IQ 측정을 원하시면 전문가가 실시하는 표준화된 검사를 받으시기 바랍니다.
                  </p>
                </div>
                
                <div className="text-center pt-4">
                  <button
                    onClick={() => {
                      setTestState('intro');
                      setCurrentSection(0);
                      setCurrentQuestion(0);
                      setAnswers({});
                      setTimer(null);
                    }}
                    className="primary-button bg-blue-600 hover:bg-blue-700 text-white py-2 px-6 rounded-lg font-medium"
                  >
                    테스트 다시 시작하기
                  </button>
                </div>
              </div>
            );
          })()}
        </div>
      )}
    </div>
  );
};

export default FormalIQTest;